import React, { useEffect } from "react";
import { Button, Alert, Row, Col } from "react-bootstrap";
import { Link, useLocation, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import FeatherIcons from "feather-icons-react";

// actions
import { resetAuth, loginUser, setUser } from "../../redux/actions";

// store
import { RootState, AppDispatch } from "../../redux/store";

// components
import { VerticalForm, FormInput } from "../../components/";

import AuthLayout from "./AuthLayout";

// images
import logoDark from "../../assets/images/logo-dark.png";
// import logoLight from "../../assets/images/aiims_logo_sms.jpg";
import logoLight from "../../assets/images/logo.jpg";
import NavBar from "../landing/NavBar";

// import logoLight from "../../assets/images/aiimslogo.png";

interface UserData {
  email: string;
  password: string;
  punchingid: string;
}

/* bottom links */
const BottomLink = () => {
  const { t } = useTranslation();

  return (
    <Row className="mt-3">
      <Col xs={12} className="text-center">
        <p className="text-muted">
          {t("Don't have an account?")}{" "}
          <Link to={"/auth/register"} className="text-primary fw-bold ms-1">
            {t("Sign Up")}
          </Link>
        </p>
      </Col>
    </Row>
  );
};

const Login = () => {
  const { t } = useTranslation();
  // dispatch helps to send data from react to redux action
  const dispatch = useDispatch<AppDispatch>();

  // takes user details from store
  const { user, userLoggedIn, loading, error } = useSelector(
    (state: RootState) => ({
      user: state.Auth.user,
      loading: state.Auth.loading,
      error: state.Auth.error,
      userLoggedIn: state.Auth.userLoggedIn,
    })
  );

  useEffect(() => {
    dispatch(resetAuth());
  }, [dispatch]);

  /*
    form validation schema
    */
  const schemaResolver = yupResolver(
    yup.object().shape({
      // email: yup.string().required(t("Please enter Email")),
      password: yup.string().required(t("Please enter Password")),
      // punchingid: yup.string().required(t("Please enter Punching I'd")),
      // checkbox: yup.bool().oneOf([true]),
    })
  );

  /*
    handle form submission
    */
  const onSubmit = async (formData: UserData) => {
    dispatch(
      loginUser(formData["email"], formData["password"], formData["punchingid"])
    );
  };

  const location = useLocation();
  // const redirectUrl = location?.search?.slice(6) || "/dashboard/ecommerce";
  const redirectUrl = location?.search?.slice(6) || "/dashboard/crc";

  return (
    <>
      <NavBar />
      {userLoggedIn || user ? <Navigate to={redirectUrl}></Navigate> : null}
      {/* bottomLinks={<BottomLink />} */}
      {/* <div
        style={{
          backgroundImage:
            "url('../assets_landing/images/school page login bannner.jpg')",
          backgroundSize: "cover",
        }}
      > */}

      <div
        style={{ position: "relative", height: "100vh", overflow: "hidden" }}
      >
        <video
          autoPlay
          loop
          muted
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            minWidth: "100%",
            minHeight: "100%",
            width: "auto",
            height: "auto",
            // zIndex: "1",
            objectFit: "cover",
            opacity: "2 ",
          }}
        >
          <source src="../assets_landing/LoginVideo6mb.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <AuthLayout layoutTitle={"ADMIN LOGIN"}>
          <div>
            {" "}
            {/* <div className="auth-logo mx-auto">
              <Link to="/" className="logo logo-dark text-center">
                <span className="logo-lg">
                  <img
                    src={logoLight}
                    alt=""
              
                    className="img-fluid"
                  />
                </span>
              </Link>

              <Link to="/" className="logo logo-light text-center">
                <span className="logo-lg">
                  <img src={logoLight} alt="" height="24" />
                </span>
              </Link>
            </div> */}
            <h3 className="h3 mb-3 mt-3 text-center text-light">
              {t("WELCOME TO DASHBOARD LOGIN")}
            </h3>
            {/* <p className="text-muted mt-1 mb-4">
          {t("Enter your email address and password to access admin panel.")}
        </p> */}
            {error && (
              <Alert variant="danger" className="my-2">
                {error}
              </Alert>
            )}
            <VerticalForm<UserData>
              onSubmit={onSubmit}
              resolver={schemaResolver}
              defaultValues={{ email: "", password: "" }}
              // defaultValues={{ email: "shreyu@coderthemes.com", password: "test" }}
              formClass="authentication-form"
            >
              {/* <FormInput
                type="text"
                name="punchingid"
                label={t("Punching I'd")}
                autoComplete="off"
                startIcon={
                  <FeatherIcons icon={"user-check"} className="icon-dual" />
                }
                placeholder={t("20242512")}
                containerClass={"mb-3"}
              />
              <p className="text-muted">OR</p> */}
              <FormInput
                type="text"
                name="email"
                label={t("Udise Code")}
                autoComplete="off"
                startIcon={<FeatherIcons icon={"mail"} className="icon-dual" />}
                placeholder={t("**********")}
                containerClass={"mb-3"}
                labelClassName={"text-warning"}
              />
              
              <FormInput
                type="password"
                name="password"
                label={t("Password")}
                autoComplete="off"
                startIcon={<FeatherIcons icon={"lock"} className="icon-dual" />}
                action={
                  <Link
                    to="/auth/forget-password"
                    className="float-end text-light text-unline-dashed ms-1"
                  >
                    {t("Forgot your password?")}
                  </Link>
                }
                placeholder={t("Enter your Password")}
                containerClass={"mb-3"}
                labelClassName={"text-warning"}
              ></FormInput>

              {/* <FormInput
            type="checkbox"
            name="checkbox"
            label={t("By clicking Log In, you agree to our Terms & conditions")}
            containerClass={"mb-3"}
            defaultChecked
          /> */}

              <div className="mb-3 text-center d-grid">
                <Button type="submit" disabled={loading}>
                  {t("Log In")}
                </Button>
              </div>
            </VerticalForm>
          </div>
        </AuthLayout>
      </div>
    </>
  );
};
export default Login;
